export default __webpack_public_path__ + "static/media/gallery_06.07c076c7.jpg";